import type { Messages } from './en'

export const pt: Messages = {
  'common.back': 'Voltar',
  'common.opensInNewTab': 'abre numa nova aba',
  'omnidek.openPortal': 'Abrir o portal Omnidek',
  'auth.signedOut': 'Você foi desconectado.',
  'auth.login': 'Entrar',

  'language.label': 'Selecionar idioma',

  'nav.home': 'Início',
  'nav.calendar': 'Calendário',
  'nav.training': 'Formação',
  'nav.profile': 'Perfil',
  'nav.primary': 'Navegação principal',

  'splash.welcome': 'Bem-vindo',
  'splash.loading': 'A carregar o EDF SuperApp',

  // Início — variante prospecto (saudação, acessibilidade do carrossel, cartão de contato).
  'home.greeting': 'Bem-vindo de volta',
  'home.editName': 'Editar nome',
  'home.assetId': 'Asset ID',
  'home.carousel.label': 'Destaques',
  'home.carousel.prev': 'Anterior',
  'home.carousel.next': 'Próximo',
  'home.carousel.goToSlide': 'Ir para o slide {number}',
  'home.carousel.slide1.alt': 'Destaque 1',
  'home.carousel.slide2.alt': 'Destaque 2',
  'home.carousel.slide3.alt': 'Destaque 3',
  'home.contact.title': 'Fale conosco',
  'home.contact.body':
    'Tem alguma dúvida ou precisa de ajuda? Nossa equipe está aqui para ajudar — entre em contato e responderemos em breve.',
  'home.contact.cta': 'Enviar mensagem',
  'home.feature.title': 'Capital privado para um crescimento económico inclusivo',
  'home.feature.cta': 'Concluir candidatura',
  'home.apply.cta': 'CONCLUIR CANDIDATURA',
  'home.feature.imageAlt': 'Pais sorrindo com o filho pequeno nos ombros do pai',

  'applicationStatus.title': 'Estado da candidatura',
  'applicationStatus.overview': 'Resumo',
  'applicationStatus.status.completed': 'Concluído',
  'applicationStatus.status.underReview': 'Em análise',
  'applicationStatus.status.draft': 'Rascunho',
  'applicationStatus.status.actionRequired': 'Ação necessária',
  'applicationStatus.status.inProgress': 'Em curso',
  'applicationStatus.card.nextSteps': 'Próximos passos',
  'applicationStatus.card.viewDetails': 'Ver detalhes',
  'applicationStatus.card.continue': 'Continuar',

  'applicationOfInterest.title': 'Manifestação de interesse',

  'application.title': 'Candidatura KYC',
  'application.loading': 'A carregar candidatura KYC...',
  'upload.sectionNotOpen': 'Esta secção ainda não está aberta para carregamentos.',
  'upload.docAlreadyPassed': 'Este documento já foi aprovado — não é necessário novo carregamento.',
  'upload.documentUnderReview':
    'Este documento já está em revisão. Se você enviou o arquivo errado por engano, entre em contato com o suporte em support@economicdevelopmentfund.com.',
  'upload.invalidFileType':
    'Apenas arquivos PDF e imagens (PNG, JPEG, WebP, GIF, BMP) são suportados para visualização no navegador. Por favor envie um formato aceito.',
  'upload.fileTooLarge': 'O tamanho do arquivo excede o limite de 10 MB. Por favor envie um arquivo menor.',
  'upload.budgetNotEditable': 'Este orçamento está em revisão ou já foi aprovado.',
  'upload.invoiceNotConfirmed': 'Não foi possível confirmar o envio da fatura. Tente novamente.',
  'upload.invoiceOpenFailed': 'Não foi possível abrir a fatura. Tente novamente.',

  // KYC step gating on /apply — what shows instead of (or over) the form.
  'kyc.submitting': 'A enviar a sua candidatura...',
  'kyc.waiting.title': 'Os seus documentos estão em análise',
  'kyc.waiting.body':
    'Carregou tudo o que precisamos por agora. A nossa equipa está a analisar os seus documentos — avisaremos assim que houver novidades ou um novo passo a concluir.',
  'kyc.complete.title': 'O seu KYC está concluído',
  'kyc.complete.body':
    'Todos os seus documentos foram analisados e aprovados. Não há mais nada para carregar.',
  'kyc.failed.title': 'Um documento precisa da sua atenção',
  'kyc.failed.intro':
    'O documento seguinte foi analisado e não pôde ser aceite. Por favor carregue um substituto.',
  'kyc.failed.noReason': 'Não foi indicado um motivo. Por favor carregue o documento novamente.',
  'kyc.failed.continue': 'Continuar',
  'kyc.submitted.dialog.title': 'Submissão Recebida',
  'kyc.submitted.dialog.body':
    'A sua candidatura KYC e documentos foram submetidos com sucesso e estão atualmente em análise pela nossa equipa.',
  'kyc.submitted.dialog.viewStatus': 'Ver estado da candidatura',
  'kyc.submitted.dialog.done': 'Concluído',
  'kyc.panel.action.status': 'Ver estado da candidatura',
  'kyc.panel.action.home': 'Voltar ao início',

  'profile.logout': 'Terminar sessão',

  'pwa.install.banner.title': 'Baixe o app da EDF',
  'pwa.install.banner.body': 'Acesso mais rápido e um atalho na sua tela inicial',
  'pwa.install.cta': 'Instalar',
  'pwa.install.dismiss': 'Fechar',

  'stageBar.important.prefix': 'Importante',
  'stageBar.apply.label': 'Conclua a sua candidatura para continuar',

  'nextStep.dialog.title': 'Próximos passos',
  'nextStep.dialog.nda.body':
    'Obrigado pelo seu interesse nos serviços do The Economic Development Fund. Para dar seguimento ao seu interesse, complete, assine e submeta o acordo de confidencialidade (NDA).',
  'nextStep.dialog.kyc.body':
    'Obrigado pelo seu interesse nos serviços do The Economic Development Fund. Para continuar com a sua candidatura, complete e submeta o formulário KYC (Know Your Customer).',
  'nextStep.dialog.close': 'Fechar',
  'nextStep.dialog.next': 'Seguinte',
}
